import { Selection } from "d3";
import { D3Selection } from "svg/draw/draw-calendar";
import { CalendarSizeDimensions } from "svg/constants";
import { addRubberBandDropShadowDef } from "svg/draw/draw-svg-dropshadow";
import { RubberBandItem } from "burde";

const drawRubberBand = (
    svg: D3Selection,
    rubberBand: RubberBandItem,
    calendarDimensions: CalendarSizeDimensions,
) => {
    if (svg.select("#rubber-band-drop-shadow").empty()) {
        addRubberBandDropShadowDef(svg);
    }

    svg.select("defs")
        .append("pattern")
        .attr("id", "rubberband-pattern")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", calendarDimensions.snoddWidth)
        .attr("height", calendarDimensions.snoddImageHeight)
        .attr("patternUnits", "userSpaceOnUse")
        .append("svg:image")
        .attr("xlink:href", `/images/${rubberBand.image}`)
        .attr("width", calendarDimensions.snoddWidth)
        .attr("height", calendarDimensions.snoddImageHeight)
        .attr("preserveAspectRatio", "none");

    // NOTE(Jesper): Draws shadow of the rubber band
    svg.append("rect")
        .attr("rx", 6)
        .attr("class", "rubberBand")
        .attr("fill", "rgba(0,0,0,0.15)")
        .attr("width", calendarDimensions.snoddWidth)
        .attr("height", calendarDimensions.snoddTotalHeight - 10)
        .attr("preserveAspectRatio", "none")
        .attr(
            "transform",
            `translate(${calendarDimensions.snoddStartPosX - 7} ${
                calendarDimensions.snoddStartPosY + 5
            })`,
        )
        .style("filter", `url(#rubber-band-drop-shadow)`);

    // NOTE(Jesper): Draws the actual rubber band
    svg.append("rect")
        .attr("rx", 10)
        .attr("class", "rubberBand")
        .attr("width", calendarDimensions.snoddWidth)
        .attr("height", calendarDimensions.snoddTotalHeight)
        .attr("fill", `url(#rubberband-pattern)`)
        .attr("preserveAspectRatio", "none")
        .attr(
            "transform",
            `translate(${calendarDimensions.snoddStartPosX} ${calendarDimensions.snoddStartPosY})`,
        );
};

export { drawRubberBand };
